import { createFileRoute, Outlet } from "@tanstack/react-router"
import { useEffect } from "react"

/**
 * Settings layout route
 */
export const Route = createFileRoute("/_authenticated/$orgSlug/settings")({
  loader: ({ params }) => {
    return {
      title: "Configurações",
      path: `/${params.orgSlug}/settings`,
    }
  },
  component: SettingsLayout,
})

function SettingsLayout() {
  const path = Route.useLoaderData()
  const { breadcrumbs } = Route.useRouteContext()

  useEffect(() => {
    breadcrumbs.setCurrentPath(path)
  }, [breadcrumbs, path])

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight md:text-3xl">Configurações</h1>
        <p className="text-muted-foreground">
          Gerencie as configurações da sua organização
        </p>
      </div>
      <Outlet />
    </div>
  )
}
